export default "__VITE_ASSET__DKTik3oG__"